if (typeof window !== "undefined") {
  const dsn = import.meta.env.VITE_SENTRY_DSN;

  if (!dsn) {
    if (import.meta.env.DEV) {
      console.warn("VITE_SENTRY_DSN is not defined. Browser Sentry is disabled.");
    }
  } else {
    const startSentry = () => {
      void import("@sentry/tanstackstart-react").then((Sentry) => {
        if (Sentry.getClient()) return;

        Sentry.init({
          dsn,
          sendDefaultPii: true,
          tracesSampleRate: 1.0,
          replaysSessionSampleRate: 0,
          replaysOnErrorSampleRate: 0,
          integrations: [Sentry.browserTracingIntegration()],
        });
      });
    };

    if (window.requestIdleCallback) {
      window.requestIdleCallback(startSentry, { timeout: 2000 });
    } else {
      window.setTimeout(startSentry, 0);
    }
  }
}
